import React from 'react';
import { Button } from '../../ui/Button';
import { GridEditorActions } from '../../GridEditorPresenter';
import {
  Activity,
  Move,
  Link,
} from 'lucide-react';
import { PowerPlantIcon, PoleIcon, MeterIcon, TransformerIcon } from '../icons/ToolIcons';

interface ToolsPanelProps {
  selectedTool: string;
  connectionStart: string | null;
  actions: Pick<GridEditorActions, 'setSelectedTool'>;
}

export const ToolsPanel: React.FC<ToolsPanelProps> = ({
  selectedTool,
  connectionStart,
  actions
}) => {
  const tools = [
    { id: 'select', label: 'Sélectionner', icon: Activity },
    { id: 'move', label: 'Déplacer', icon: Move },
    { id: 'connect', label: 'Connecter', icon: Link },
    { id: 'power-plant', label: 'Centrale', icon: PowerPlantIcon },
    { id: 'pole', label: 'Poteau', icon: PoleIcon },
    { id: 'meter', label: 'Compteur', icon: MeterIcon },
    { id: 'transformer', label: 'Transformateur', icon: TransformerIcon }
  ];

  return (
    <div className="p-4 border-b border-slate-200">
      <h3 className="text-sm font-medium text-slate-900 mb-3">Outils</h3>
      <div className="grid grid-cols-2 gap-2">
        {tools.map((tool) => {
          const Icon = tool.icon;
          return (
            <Button
              key={tool.id}
              variant={selectedTool === tool.id ? 'primary' : 'outline'}
              size="sm"
              onClick={() => actions.setSelectedTool(tool.id)}
              className="flex flex-col items-center p-3 h-auto"
            >
              <Icon className="h-4 w-4 mb-1" />
              <span className="text-xs">{tool.label}</span>
            </Button>
          );
        })}
      </div>
      
      {selectedTool === 'connect' && connectionStart && (
        <div className="mt-3 p-2 rounded-lg backdrop-blur-sm border border-gray-300" style={{ backgroundColor: '#ffffffb4' }}>
          <p className="text-xs text-gray-800">
            Cliquez sur un autre élément pour créer une connexion
          </p>
        </div>
      )}
    </div>
  );
};
